<template>
  <div>
    <div v-if="isList">
      <h2 style="margin: 20px">角色管理</h2>
      <mn-btns :btnList="listBtns" class="mn-btns" />
      <md-form :inline="true" :model="formHead" class="demo-form-inline form-demo-02">
        <md-form-item label="角色名称">
          <md-input v-model="formHead.roleNameZh" placeholder="请输入角色名称" clearable @clear="onSubmit('init')"></md-input>
        </md-form-item>
        <md-form-item label="角色标识">
          <md-input v-model="formHead.roleCode" placeholder="请输入角色标识" clearable @clear="onSubmit('init')"></md-input>
        </md-form-item>
        <md-form-item>
          <md-button type="primary" @click="onSubmit('init')">查询</md-button>
        </md-form-item>
      </md-form>
      <md-table ref="list" :data="tableData" style="width: 100%; margin-bottom: 20px" :height="height">
        <md-table-column type="index" width="50"></md-table-column>
        <md-table-column prop="roleNameZh" label="角色名称" minWidth="200"></md-table-column>
        <md-table-column prop="roleCode" label="角色标识" minWidth="200"></md-table-column>
        <md-table-column prop="createUserName" label="操作人" minWidth="140"></md-table-column>
        <md-table-column prop="status" label="状态" minWidth="100">
          <template slot-scope="scope">
            {{ scope.row.status === "Y" ? "有效" : "无效" }}
          </template>
        </md-table-column>
        <md-table-column prop="createTime" label="创建时间" minWidth="200"></md-table-column>
        <md-table-column label="操作" minWidth="300">
          <template slot-scope="scope">
            <div v-for="item in btnList" :key="item.id" style="float: left;">
              <md-button @click="item.handel(scope.row)" class="editBtn">{{ item.label }}</md-button>
            </div>
          </template>
        </md-table-column>
      </md-table>
      <div>
        <md-pagination
          style="float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSetting.size"
          :current-page="pageSetting.current"
          layout="total, prev, pager, next, sizes,jumper"
          :total="pageSetting.total"
        ></md-pagination>
      </div>
    </div>
    <div v-if="!isList">
      <setRole
        :row="roleRow"
        @back="
          () => {
            this.isList = true;
            this.onSubmit();
          }
        "
      />
    </div>

    <!-- 新增弹框 -->
    <addDialog ref="addDialog" @sbmitForm="sbmitForm" v-if="dialogVisible" :options="options" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import axios from 'axios';
// import base from '@/modules/index/mixins/base.js';
import addDialog from './dialog/add-dialog.vue';
import setRole from './set-role.vue';
import mnBtns from '../MnBtns/index.vue';

export default {
  name: 'role-manage',
  components: { addDialog, setRole, mnBtns },
  mixins: [],
  data() {
    return {
      tableData: [],
      height: null,
      btnList: [
        { label: '授权菜单资源', id: 1, handel: this.setRole },
        { label: '修改', id: 2, handel: this.edit },
        { label: '删除', id: 3, handel: this.delete },
        { label: '查看', id: 4, handel: this.check },
      ],
      formHead: {
        roleNameZh: '',
        roleName: '',
        roleCode: '',
        roleType: '',
      },
      options: [], // 角色类型下拉选项
      isList: true,
      pageSetting: {
        current: 1,
        size: 10,
        total: 0,
      },
      listBtns: [
        {
          name: '新增',
          handle: this.add,
        },
        {
          name: '导出',
          handle: this.export,
        },
      ],
      dialogVisible: false,

      roleRow: {},
    };
  },

  mounted() {
    this.queryList();
    const table = this.$refs.list;
    const tops = table.$el.getBoundingClientRect().top;
    if (tops > 0) {
      this.height = window.innerHeight - tops - 80 + 'px';
    }
  },

  methods: {
    // -------------------------初始化----------------------------
    // #region
    // 查询
    queryList(params = {}) {
      axios
        .post('/gscint/role/page', {
          ...params,
          current: this.pageSetting.current,
          size: this.pageSetting.size,
        })
        .then((res) => {
          if (res.data.data.code === '1') {
            this.tableData = res.data.data.datas.list;
            this.pageSetting.total = res.data.data.datas.total;
          } else {
            this.$MdMessage.warning(res.data.data.datas);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSetting.size = val;
      this.onSubmit();
    },
    handleCurrentChange(val) {
      this.pageSetting.current = val;
      this.onSubmit();
    },
    onSubmit(type) {
      if (type === 'init') {
        this.pageSetting.current = 1;
      }
      this.queryList(this.formHead);
    },
    // #endregion

    // -----------------------------------------------列表页按钮----------------------------------------
    // #region
    // 新增
    add() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addDialog.visible = true;
      });
    },
    // 关闭弹框
    closeDialog() {
      this.dialogVisible = false;
    },
    // 弹框返回
    sbmitForm(form) {
      const url = form.baseRoleId ? '/gscint/role/update' : '/gscint/role/add';
      axios.post(url, form).then((res) => {
        if (res.data.data.code === '1') {
          this.$MdMessage.success('保存成功');
          this.onSubmit('init');
          this.dialogVisible = false;
        } else {
          this.$MdMessage.warning(res.data.data.msg);
        }
      });
    },
    downloadFile(data, filename) {
      if (!data) {
        return;
      }
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    export() {
      const params = {
        current: this.pageSetting.current,
        size: this.pageSetting.size,
      };

      axios({
        url: '/gscint/role/export',
        method: 'post',
        data: params,
        headers: { 'content-type': 'application/json; charset=utf-8' },
        responseType: 'blob',
      }).then((res) => {
        this.downloadFile(res.data, '角色导出.xlsx');
      });
    },

    // -------------------------------表格操作按钮---------------------------------
    // #region
    // 授权菜单资源
    setRole(row) {
      this.isList = false;
      this.roleRow = row;
    },
    // 修改
    edit(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addDialog.form = Object.assign({}, row);
        this.$refs.addDialog.title = '修改菜单';
        this.$refs.addDialog.visible = true;
      });
    },
    // 删除
    delete(row) {
      this.$MdConfirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
      }).then(() => {
        axios
          .post('/gscint/role/delete', {
            baseRoleId: row.baseRoleId,
          })
          .then((res) => {
            if (res.data.data.code === '1') {
              this.$MdMessage.success('删除成功');
            } else {
              this.$MdMessage.warning(res.data.msg);
            }
          });
      });
    },
    // 查看
    check(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addDialog.title = '查看菜单';
        this.$refs.addDialog.form = Object.assign({}, row);
        this.$refs.addDialog.readonly = true;
        this.$refs.addDialog.visible = true;
      });
    },

    // #endregion
  },
};
</script>

<style lang="less" scoped>
.mn-btns {
  display: inline-block;
  width: auto;
}
.title {
  /deep/.head-title {
    font-size: 20px;
  }
}
.editBtn {
  border: none;
  background: rgba(0, 0, 0, 0);
  padding: 0;
  margin-right: 8px;
  color: rgb(86, 163, 250);
  &:hover {
    background: rgba(0, 0, 0, 0);
    color: rgb(124, 185, 255);
  }
}
</style>
<style lang="less">
.demo-form-inline {
  float: right;
  height: 54px;
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
    margin-right: 12px;
  }
}
.form-demo-02 {
  .el-form-item {
    .el-form-item__label {
      padding-right: 8px;
    }
  }
}
</style>
